import Vue from 'vue';
import { getRoutes } from './routes';
import VueRouter from 'vue-router';
import { i18nInstance } from '@/plugins/i18n';

let router = null;
const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location, onResolve, onReject) {
	if (onResolve || onReject) {
		return originalPush.call(this, location, onResolve, onReject);
	}

	return originalPush.call(this, location).catch(err => {
		// redirected, aborted, cancelled, duplicated are considered
		// as NavigationFailure
		if (VueRouter.isNavigationFailure(err)) {
			// resolve err
			return err;
		}
		// rethrow error
		return Promise.reject(err);
	});
};

Vue.use(VueRouter);

function nextFactory(context, middleware, index) {
	const subsequentMiddleware = middleware[index];
	if (!subsequentMiddleware) return context.next;
	return (...parameters) => {
		context.next(...parameters);
		const nextMiddleware = nextFactory(context, middleware, index + 1);
		subsequentMiddleware({ ...context, next: nextMiddleware });
	};
}

const getRouter = () => {
	if (!router) {
		const routes = getRoutes();
		router = new VueRouter({
			mode: 'history',
			routes
		});
		router.afterEach(to => {
			Vue.nextTick(() => {
				const metaTitle = to.meta.title || '';
				const docTitle = i18nInstance
					.t('generalMetaTitles.default')
					.split(' | ');

				if (metaTitle !== '') {
					if (to.path.includes('admin')) {
						docTitle.unshift('Admin');
					}

					docTitle.unshift(metaTitle);
				}

				document.title = docTitle.join(' | ');
			});
		});

		router.beforeEach((to, from, next) => {
			if (to.meta.middleware) {
				const middleware = Array.isArray(to.meta.middleware)
					? to.meta.middleware
					: [to.meta.middleware];
				const context = {
					from,
					next,
					router,
					to
				};
				const nextMiddleware = nextFactory(context, middleware, 1);
				return middleware[0]({ ...context, next: nextMiddleware });
			}
			return next();
		});
	}
	return router;
};

export { getRouter, router };
